import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0.5 0C0.312706 0 0.141118 0.104674 0.0554162 0.271209C-0.030286 0.437745 -0.015729 0.638212 0.0931333 0.790619L5 7.66023V13.5C5 13.6844 5.10149 13.8538 5.26407 13.9408C5.42665 14.0278 5.62392 14.0183 5.77735 13.916L8.77735 11.916C8.91645 11.8233 9 11.6672 9 11.5V7.66023L13.9069 0.790619C14.0157 0.638212 14.0303 0.437745 13.9446 0.271209C13.8589 0.104674 13.6873 0 13.5 0H0.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }